/* PDP: pre-select the Most Popular weight as the default, with an out-of-stock fallback.
   Runs only when the URL doesn't already request a specific variant. */
(function () {
  function selectDefault(picker) {
    const popular = (picker.dataset.popularDefault || '').trim().toLowerCase();
    if (!popular) return;
    const behaviour = picker.dataset.oosBehaviour === 'stay' ? 'stay' : 'next';
    const radios = Array.from(picker.querySelectorAll('.product-form__input--button input[type="radio"]'));
    if (!radios.length) return;

    const isAvailable = (radio) => radio && radio.dataset.variantAvailable === 'true';
    const popularRadio = radios.find((radio) => (radio.value || '').trim().toLowerCase() === popular);
    if (!popularRadio) return;

    let target = popularRadio;
    if (!isAvailable(popularRadio) && behaviour === 'next') {
      const start = radios.indexOf(popularRadio);
      target = radios.slice(start + 1).find(isAvailable) || radios.find(isAvailable) || popularRadio;
    }

    if (target && !target.checked) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function init() {
    if (new URLSearchParams(window.location.search).has('variant')) return;
    document.querySelectorAll('variant-selects[data-popular-default]').forEach(selectDefault);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
